
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus-rounded': {
    width: 14.1,
    height: 14.1,
    viewBox: '0 0 14.1 14.1',
    data: '<path pid="0" d="M12.1 2.1c-2.8-2.8-7.2-2.8-10 0s-2.8 7.2 0 10 7.2 2.8 10 0c2.7-2.8 2.7-7.3 0-10zm-1.5 5.7H8.2v2.4c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7V7.8H4.3c-.5 0-.8-.4-.8-.8s.4-.7.8-.7h2.4V3.9c0-.4.3-.7.7-.7.4 0 .7.3.7.7v2.4h2.4c.4 0 .7.3.7.7.2.5-.2.8-.6.8z"/>'
  }
})
